import Product from "./ProductItem";
import ProductH from "./ProductItemH";
import { useEffect, useState } from "react";
import { fa_number } from "../../utils/PersianNum";
import Sidebar from "./Sidebar";

function ProductList({products,categories}) {
  const [viewType, setViewType] = useState({ grid: true });
  const [prods,setProds] = useState()

  const [state, setState] = useState({
    cat : 0,
    quant: false,
    search: "",
    sale: false
  })

  useEffect(() => {
    setProds(products)
  }, [products])

  const onSubmit = (e) => {
    e.preventDefault()
    if(state.search !== "") {
      setProds(products.filter(item => item.name.toLowerCase().indexOf(state.search) > -1))
      setState((prev) => ({ ...prev, search: "" }))
    }
    if(state.cat !== 0) {
      setProds(products.filter(item => item.cat_id === state.cat))
      setState((prev) => ({ ...prev, cat: 0 }))
    }
    if(state.quant) {
      setProds(products.filter(item => item.quantity > 0))
      setState((prev) => ({ ...prev, quant: false }))
    }
    if(state.sale) {
      setProds(products.filter(item => item.sale_price !== null))
      setState((prev) => ({ ...prev, sale: false }))
    }
  }

  const sorting = (order) => {
    if (order === 'name')
      setProds(prods.toSorted((a, b) => a.name.localeCompare(b.name)));
    if (order === 'high')
      setProds(prods.toSorted((a, b) => b.price - a.price));
    if (order === 'low')
      setProds(prods.toSorted((a, b) => a.price - b.price));
  }

  return (
    <div className="container mt-4 py-4 px-xl-2">
      <div className="h-scroller d-block d-lg-none">
        <nav className="nav h-underline mb-3">
          {categories.map((v, i) => {
            return (
              <form key={i} className="h-link ms-2 mt-0" onSubmit={(e) =>  onSubmit(e)}>
                <button type="submit" onClick={() => setState((prev) => ({ ...prev, cat: +v.id }))} className="btn btn-sm btn-outline-dark rounded-pill">
                    {v.name}
                </button>
              </form>
            );
          })}
        </nav>
      </div>

      <div className="row mb-3 d-block d-lg-none">
        <div className="col-12">
          <div id="accordionFilter" className="accordion shadow-sm">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFilter"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                >
                  فیلتر محصولات
                </button>
              </h2>
            </div>
            <div
              id="collapseFilter"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionFilter"
            >
              <div className="accordion-body p-0">
                <Sidebar cats={categories} state={state} setState={setState} onSubmit={onSubmit}/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4 mt-lg-3">
        <div className="d-none d-lg-block col-lg-3">
          <div className="border rounded shadow-sm">
            <Sidebar cats={categories} state={state} setState={setState} onSubmit={onSubmit}/>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="d-flex flex-column h-100">
            <div className="row mb-3">

              <div className="col-lg-3 d-none d-lg-block" >
                <select
                  className="form-select"
                  aria-label="select product order"
                  defaultValue=""
                  // onChange={(e) => {setSort( e.target.value)}}
                >
                  <option onClick={() => {sorting('')}} value="">مرتب سازی براساس...</option>
                  <option onClick={() => {sorting('high')}} value="high">گران ترین</option>
                  <option onClick={() => {sorting('low')}} value="low">ارزان ترین</option>
                  <option onClick={() => {sorting('name')}} value="name">نام محصول</option>
                </select>
              </div>

              <div className="col-lg-9 col-xl-5 offset-xl-4 d-flex flex-row">
                <form className="input-group" onSubmit={onSubmit}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="جستجوی محصول..."
                    aria-label="search input"
                    onChange={(e) => setState((prev) => ({ ...prev, search: e.target.value }))}
                  />
                  <button type="submit" className="btn btn-outline-dark">
                    <i className="fas fa-search"></i>
                  </button>
                </form>
                <button className="btn btn-outline-dark ms-2 d-none d-lg-inline" onClick={() => setViewType({grid: !viewType.grid})} >
                  <i className={"fas " + (viewType.grid ? "fa-th-list" : "fa-th-large")}></i>
                </button>
              </div>
            </div>

            <div className={"row row-cols-1 row-cols-md-2 row-cols-lg-2 g-3 mb-4 flex-shrink-0 " + (viewType.grid ? "row-cols-xl-3" : "row-cols-xl-2")}>
              {prods && prods.length > 0 ? 
                prods.map((v, i) => {
                  if (viewType.grid)
                    return (<Product key={i} prod={v}/>)
                  return (<ProductH key={i} prod={v}/>)
                })
                :
                  <p className="mt-4 border rounded">محصولی موجود نیست!</p>
              }
            </div>
            <div className="d-flex align-items-center mt-auto">
              {prods && <span className="text-muted small d-none d-md-inline">
                نمایش {fa_number(prods.length)} از {fa_number(prods.length)}
              </span>}
              {prods && <nav aria-label="Page navigation" className="ms-auto pagination">
                <ul className="pagination my-0 text-dark">
                  <li className="page-item">
                    <a className="page-link text-dark" href="!#">
                      قبلی
                    </a>
                  </li>
                  <li className="page-item active">
                    <a className="page-link text-dark" href="!#">
                      ۱
                    </a>
                  </li>
                  <li className="page-item">
                    <a className="page-link text-dark" href="!#">
                      بعدی
                    </a>
                  </li>
                </ul>
              </nav>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductList;
